import { Navigate, Route, Routes } from "react-router-dom";
import SignIn from "./pages/authentication/SignIn";
import ForgetPassword from "./pages/authentication/ForgetPassword";
import ResetPassword from "./pages/authentication/ResetPassword";
import ManageAdmin from "./pages/manageRoles/ManageAdmin";
import ManageTenants from "./pages/manageRoles/ManageTenants";
import ManageCategory from "./pages/manageRoles/ManageCategory";
import ManageBreef from "./pages/manageBreef/ManageBreef";
import ProtectedRoutes from "./protectedRoutes";
import NotFound from "./utils/NotFound";
import Logout from "./pages/home/Logout";
import UpdateViewBreef from "./pages/manageBreef/UpdateViewBreef";
import UpdateViewEditTenant from "./pages/manageRoles/UpdateViewEditTenant";
import Game from "./pages/game/Game";
import UpdateViewGame from "./pages/game/UpdateViewGame";
import UpdateViewTeam from './manageTeam/UpdateViewTeam'
import Survey from "./pages/unsubscription/Survey";
import UpdateBreefSetting from "./pages/setting/UpdateBreefSetting";
import Levels from "./pages/levels/Levels";
import Mails from "./pages/mails/Mails";
import Logs from "./pages/logs/Logs";
import PlatformSettings from "./pages/platformSettings/PlatformSettings";
import ManageUsers from "./pages/manageUsers/ManageUsers";
import ManageTeams from "./pages/manageTeams/ManageTeams";
import UpdateViewEditUsers from "./pages/manageUsers/UpdateViewEditUser";
import UpdateBreefAndScore from "./pages/manageUsers/UpdateBreefAndScore";
import Score from "./pages/home/Score";
import BreefTrackingDetail from "./pages/breefTracking/BreefTrackingDetail";
import CronJobs from "./pages/cronJobs/CronJobs";
import Queues from "./pages/queues/Queues";
import Stats from "./pages/stats/Stats";
import LegalDocuments from "./pages/legal/LegalDocuments";
import Media from "./pages/media/Media";

export default function Router() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/manage-admin" element={<ManageAdmin />} />
          <Route path="/manage-tenant" element={<ManageTenants />} />
          <Route path="/manage-users" element={<ManageUsers/>} />
          <Route path="/manage-teams" element={<ManageTeams/>} />
          <Route path="/manage-category" element={<ManageCategory />} />
          <Route path="/manage-breef" element={<ManageBreef />} />
          <Route path="/home" element={<Score />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/breef/:breefId" element={<UpdateViewBreef />} />
          <Route path="/team/:teamId" element={<UpdateViewTeam />} />
          <Route path="/tenant/:tenantId" element={<UpdateViewEditTenant />} />
          <Route path="/user/:userId" element={<UpdateViewEditUsers/>} />
          
          <Route path="/breefAndScore/" element={<UpdateBreefAndScore/>} />
          <Route path="/game" element={<Game />} />
          <Route path="/survey" element={<Survey />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/platform-settings" element={<PlatformSettings />} />
          <Route path="/breef-setting" element={<UpdateBreefSetting />} />
          <Route path="/levels" element={<Levels />} />
          <Route path="/mails" element={<Mails />} />
          <Route path="/media" element={<Media />} />
          <Route path="/game/:gameId" element={<UpdateViewGame />} />
          <Route path="/breef-tracking" element={<Navigate to="/queues?tab=invites" replace />} />
          <Route path="/breef-tracking/:breefId" element={<BreefTrackingDetail />} />
          <Route path="/cron-jobs" element={<CronJobs />} />
          <Route path="/queues" element={<Queues />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/legal-documents" element={<LegalDocuments />} />
        </Route>
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </div>
  );
}
